import * as Yup from "yup";
import {
  PERK_TYPE_GENERIC,
  PERK_TYPE_INTRO_EMAIL,
  PERK_TYPE_PROMO_CODE,
  PERK_TYPE_SPECIAL_EMAIL,
  PERK_TYPE_SPECIAL_URL,
} from "constants/perksAdmin";

const isPerkType = (perkType: string) => (value: string) => value === perkType;

export const perkFormSchema = Yup.object({
  name: Yup.string().required("Name is required"),
  description: Yup.string().required("Description is required"),
  perk_type: Yup.string().required("Perk type is required"),
  contact_email: Yup.string().notRequired().email("Enter a valid email"),
  website: Yup.string().notRequired().url("Enter a valid URL"),
  linkedin_url: Yup.string().notRequired().url("Enter a valid URL"),
  promo_code: Yup.string().when("perk_type", {
    is: isPerkType(PERK_TYPE_PROMO_CODE),
    then: Yup.string().required("Promo code is required"),
  }),
  promo_code_redeem_url: Yup.string().when("perk_type", {
    is: isPerkType(PERK_TYPE_PROMO_CODE),
    then: Yup.string()
      .required("Promo code redeem URL is required")
      .url("Enter a valid URL"),
  }),
  special_url: Yup.string().when("perk_type", {
    is: isPerkType(PERK_TYPE_SPECIAL_URL),
    then: Yup.string()
      .required("Special URL is required")
      .url("Enter a valid URL"),
  }),
  intro_emails: Yup.array()
    .of(Yup.string().email("Enter a valid email"))
    .when("perk_type", {
      is: isPerkType(PERK_TYPE_INTRO_EMAIL),
      then: Yup.array().min(1, "Add at least one email"),
    }),
  special_email: Yup.string().when("perk_type", {
    is: isPerkType(PERK_TYPE_SPECIAL_EMAIL),
    then: Yup.string()
      .required("Special email is required")
      .email("Enter a valid email"),
  }),
  redeem_instruction: Yup.string().when("perk_type", {
    is: isPerkType(PERK_TYPE_SPECIAL_EMAIL),
    then: Yup.string().required("Redeem instruction is required"),
  }),
  generic_instruction: Yup.string().when("perk_type", {
    is: isPerkType(PERK_TYPE_GENERIC),
    then: Yup.string().required("Generic instruction is required"),
  }),
});
